module.exports = __webpack_public_path__ + "static/selfhelpworks-logo-a5ee227ac5b3f33a0dbc20a3d2c7443b.png";